/** @format */

import React from "react";
import { FilterOutlined } from "@ant-design/icons";

function SugorishCart(props) {
  return (
    <div className='data-sug mt-3'>
      <div className='card statistic-card px-2 pt-0'>
        <h4 className='statics4-title text-center'>
          <span>
            Sug'orilgan maydon <span className='lower'>(ming.ga)</span>
          </span>
        </h4>

        <ul className='lists'>
          <li className='w-100'>
            <div className='head tex justify-content-center'>
              <h3 className='text-center'>
                <FilterOutlined
                  style={{ fontSize: "18px", color: "#1BCB80" }}
                />
                Jami: 1 115
              </h3>
            </div>
          </li>
        </ul>

        <ul className='lists sugorish'>
          <li>
            <div className='head'>
              <h3>1 210</h3>

              <p>Paxta maydoni</p>
            </div>

            <div
              className='vertical-line'
              style={{ backgroundColor: "#FF6060" }}></div>
          </li>

          <li>
            <div className='head'>
              <h3>1 115</h3>
              <p>G'alla maydoni</p>
            </div>

            <div
              className='vertical-line'
              style={{ backgroundColor: "#FF6060" }}></div>
          </li>

          <li>
            <div className='head'>
              <h3>1 210</h3>

              <p>Tomorqa va boshqa</p>
            </div>

            <div
              className='vertical-line'
              style={{ backgroundColor: "#FF6060" }}></div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SugorishCart;
